module.exports = __webpack_public_path__ + "img/logoYc.5e2faf49.png";